import React from 'react';
import BaseText from '../typography/BaseText';
import { FONT_SIZE } from '../../../constants/enum';

export default function SelectInput({ options, inputProps, error, label, size }) {
  return (
    <div>
      <BaseText
        fontSize={size === 'sm' ? FONT_SIZE?.PX_14 : FONT_SIZE?.PX_16}
        className="py-2"
        fontWeight={size !== 'sm' && 'text-medium'}
        title={label}
      />
      <select
        className={`${
          size === 'sm' ? 'py-3  bg-gray-100 rounded-lg' : 'py-4 rounded'
        } w-full border border-gray-180  text-medium text-center px-3`}
        {...inputProps}
      >
        {options?.map((option) => {
          return <option value={option?.value}>{option?.name}</option>;
        })}
      </select>
      {error && (
        <BaseText fontSize={FONT_SIZE?.PX_14} textColor="text-red-500" title={`Please enter a valid ${error}`} />
      )}
    </div>
  );
}
